 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		88: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		88: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"6ff23ba","1":"03aa1e2","2":"780af16","3":"1e01bc5","4":"ee5eb6e","5":"91cd9ce","6":"de5d512","7":"102dfd2","10":"afdeae8","11":"3bbbeaf","12":"d384f62","13":"6fa2148","14":"c75e379","15":"3e666cd","16":"b9c244a","17":"a72a71e","18":"12abafc","19":"d010a09","20":"1ae8d78","21":"1ad6384","22":"fdb5167","23":"f01731f","24":"bb02cab","25":"29ecc66","26":"870982e","27":"3531bfe","28":"b5bbe63","29":"7936077","30":"420b859","31":"ba314fc","32":"26a6f48","33":"1ec7e6d","34":"d2349da","35":"15b03df","36":"c7f6f21","37":"c73f1b0","38":"800b20b","39":"654ae93","40":"a7997af","41":"825d2a9","42":"bd4b8a1","43":"748fe50","44":"e8519ea","45":"4b5def7","46":"28cbb06","47":"5517c40","48":"76a7b72","49":"f111887","50":"4392d5e","51":"bbc6b34","52":"7c44fc6","53":"20efd00","54":"e8f0163","55":"ffb5ea4","56":"099bcdb","57":"8ca5ccc","58":"4e8fedb","59":"45727f3","60":"49ade9a","61":"5d5258a","62":"1209c42","63":"4aad590","64":"2359d16","65":"10c354e","66":"346f509","67":"bd43503","68":"8998655","69":"c50a7b8","70":"fabfc3b","71":"287038b","72":"6f4e758","73":"3d20953","74":"b1d738f","75":"421a70e","76":"d0e8291","77":"42e9007","78":"79d01a6","79":"60ce88d","80":"1e3e28a","81":"def9ed9","82":"88d61dd","83":"c5b1a9f","84":"8474b8e","85":"d2a90c5","86":"13ccac7","87":"afef128","90":"236982a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var linkExists = false
 		var cssChunks = {"0":1,"3":1,"5":1,"6":1,"7":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"61":1,"62":1,"64":1,"65":1,"66":1,"67":1,"74":1,"75":1,"76":1,"77":1,"78":1,"79":1,"80":1,"81":1,"82":1,"83":1,"84":1,"85":1,"86":1,"87":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"0adfd3d","1":"31d6cfe","2":"31d6cfe","3":"45db0ad","4":"31d6cfe","5":"34b0e51","6":"f053ea8","7":"7d4d8b8","10":"658f6dd","11":"1c951ad","12":"c737dd3","13":"c7891ed","14":"4911beb","15":"f154f07","16":"0fc0971","17":"45db0ad","18":"b48607d","19":"ca89b16","20":"1559c09","21":"ba2437f","22":"5945f99","23":"0f002b0","24":"1af2cd0","25":"31d6cfe","26":"31d6cfe","27":"8a1dc88","28":"23cea65","29":"b61f4c3","30":"6444c0a","31":"1eb196f","32":"0adfd3d","33":"e0f8d33","34":"1248a56","35":"1965dc3","36":"a6eb623","37":"008124a","38":"ad8013b","39":"9609d1a","40":"41252cd","41":"e67f160","42":"0622589","43":"db6898c","44":"a87b97a","45":"6b9d781","46":"7d8f8fe","47":"7d8f8fe","48":"3e50d15","49":"bf4e1e4","50":"72577a9","51":"3a15aa5","52":"6175004","53":"e82f9c9","54":"23e6631","55":"e84d0ae","56":"75ccdb4","57":"93b2cfd","58":"b5d0a59","59":"800b68f","60":"1471629","61":"3cb3306","62":"a81e870","63":"31d6cfe","64":"0a48d98","65":"54ee01a","66":"5ffed85","67":"f4b68d5","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"e188424","75":"e188424","76":"e188424","77":"e188424","78":"e188424","79":"e188424","80":"e188424","81":"22eb84c","82":"e188424","83":"d89de31","84":"e188424","85":"e188424","86":"e188424","87":"e188424","90":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) {
 						linkExists = true
 						return resolve();
 					}
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(!linkExists && supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"0adfd3d","1":"31d6cfe","2":"31d6cfe","3":"45db0ad","4":"31d6cfe","5":"34b0e51","6":"f053ea8","7":"7d4d8b8","10":"658f6dd","11":"1c951ad","12":"c737dd3","13":"c7891ed","14":"4911beb","15":"f154f07","16":"0fc0971","17":"45db0ad","18":"b48607d","19":"ca89b16","20":"1559c09","21":"ba2437f","22":"5945f99","23":"0f002b0","24":"1af2cd0","25":"31d6cfe","26":"31d6cfe","27":"8a1dc88","28":"23cea65","29":"b61f4c3","30":"6444c0a","31":"1eb196f","32":"0adfd3d","33":"e0f8d33","34":"1248a56","35":"1965dc3","36":"a6eb623","37":"008124a","38":"ad8013b","39":"9609d1a","40":"41252cd","41":"e67f160","42":"0622589","43":"db6898c","44":"a87b97a","45":"6b9d781","46":"7d8f8fe","47":"7d8f8fe","48":"3e50d15","49":"bf4e1e4","50":"72577a9","51":"3a15aa5","52":"6175004","53":"e82f9c9","54":"23e6631","55":"e84d0ae","56":"75ccdb4","57":"93b2cfd","58":"b5d0a59","59":"800b68f","60":"1471629","61":"3cb3306","62":"a81e870","63":"31d6cfe","64":"0a48d98","65":"54ee01a","66":"5ffed85","67":"f4b68d5","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"e188424","75":"e188424","76":"e188424","77":"e188424","78":"e188424","79":"e188424","80":"e188424","81":"22eb84c","82":"e188424","83":"d89de31","84":"e188424","85":"e188424","86":"e188424","87":"e188424","90":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/app-hotmart-legal/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
